import { render, staticRenderFns } from "./memoryexceed.vue?vue&type=template&id=33b6c012"
import script from "./memoryexceed.vue?vue&type=script&lang=js"
export * from "./memoryexceed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports